import { render } from "./exams-course.vue?vue&type=template&id=54fb2d24"
import script from "./exams-course.vue?vue&type=script&lang=js"
export * from "./exams-course.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__